import Head from "next/head";
import { useTranslations } from "next-intl";

const ListingHead = ({ page, isFirstPage, seoTitle, seoDescription }) => {
  const t = useTranslations("common");

  const displayMetaTitle = () => {
    const subTitle = seoTitle || "";
    const currentPage = isFirstPage ? "" : ` ${t("page")} ${page}`;

    return `${subTitle} | ${t("meta.name")}${currentPage}`;
  };

  return (
    <Head>
      <title data-testid="meta-title">{displayMetaTitle()}</title>
      <meta
        name="description"
        content={seoDescription}
      />
    </Head>
  );
};

export default ListingHead;
